export default "__VITE_ASSET__3Q0dOY_3__"